import React, {useCallback, useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import useLoader from "../../../hooks/useLoader";
import {Button, CircularProgress, Grid, FormControl, InputLabel, Select, MenuItem} from "@mui/material";
import DashboardLayout from "../../../layouts/Dashboard"
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import {FORM_ATTRIBUTE_DETAIL_ROUTE, FORM_ATTRIBUTE_LIST_ROUTE} from "../../../routes";
import {formAttributeCRUD} from "../../../http";
import TextField from "@mui/material/TextField";

const FormAttributeDetailForm = () => {
    const history = useHistory()
    const {id} = useParams();
    const [isNew,setIsNew] = useState(id==="new")
    const [fields, setFields] = useState({})
    const {loading, start, stop} = useLoader(false)

    const fetch = useCallback(() => {
        start()
        if(!isNew){
            formAttributeCRUD.get(id).then(data => {
                setFields(state=>{
                    return {
                        ...state,
                        type: data.type || "",
                        member: data.member || "",
                        number: data.number || "",
                        memberType: data.memberType || "",
                        memberDescription: data.memberDescription || "",
                    }
                })
                stop()
            })
        }else{
            stop()
        }
    }, [id])

    useEffect(fetch, [fetch])

    const submit = useCallback(() => {
        const payload = { ...fields }
        if (!isNew){
            formAttributeCRUD.edit({ id:id, ...payload }).catch(err=>{ alert(err) })
        }else{
            formAttributeCRUD.create(payload).catch(err=>{ alert(err) }).then((resp)=>{setIsNew(false);history.push(FORM_ATTRIBUTE_DETAIL_ROUTE(resp.id))})
        }
    }, [id, fields])

    const deleteForm = useCallback(()=>{
        formAttributeCRUD.delete(id).then(()=>{
            history.push(FORM_ATTRIBUTE_LIST_ROUTE)
        }).catch(err=>{
            alert(err)
        })
    },[id])
    const typeOptions = ['result', 'protocol', 'act', 'direction', 'referral', 'resolution', 'prescription', 'objectReferral'];

    const memberTypeOptions = ['date', 'int', 'number', 'bigint', 'json', 'float', 'boolean', 'string', 'datetime', 'text'];

    return (
        <DashboardLayout>
            {loading ? <CircularProgress/> : <>
                <Grid item xs={12}>
                    <Paper>
                        <Toolbar style={{display:"flex", justifyContent:"space-between"}}>
                            <Typography id="modal-modal-title" variant="h5" component="h2">
                                {isNew?"Создание":"Редактирование"} Атрибут формы<br/>
                            </Typography>
                            <div>
                                <Button variant="outlined" onClick={() => history.push(FORM_ATTRIBUTE_LIST_ROUTE)} style={{marginRight: 10}}>
                                    Вернуться
                                </Button>
                                {!isNew &&
                                    <Button onClick={()=>{deleteForm()}} style={{background:"#ff4343"}}>
                                        Удалить
                                    </Button>}
                            </div>
                        </Toolbar>
                    </Paper>
                </Grid>
                <Grid item xs={12} spacing={1} style={{paddingTop: 16}}>
                    <Paper style={{paddingBottom: 20}}>
                        <Grid container xs={12} style={{paddingLeft: 20, paddingRight: 20}}>
                            <Grid item xs={12}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel id="form-attribute-type-label">Тип формы</InputLabel>
                                    <Select
                                        labelId="form-attribute-type-label"
                                        id="form-attribute-type"
                                        label="Тип формы"
                                        value={fields.type || ""}
                                        onChange={(ev) => { setFields((state) => ({ ...state, type: ev.target.value })) }}
                                        required
                                    >
                                        {typeOptions.map(opt => (
                                            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField required margin="normal"
                                           fullWidth label="Member"
                                           onChange={(ev) => { setFields((state) => ({ ...state, member: ev.target.value })) }}
                                           value={fields.member || ""}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField margin="normal"
                                           fullWidth label="Number"
                                           onChange={(ev) => { setFields((state) => ({ ...state, number: ev.target.value })) }}
                                           value={fields.number || ""}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel id="form-attribute-memberType-label">Тип поля</InputLabel>
                                    <Select
                                        labelId="form-attribute-memberType-label"
                                        id="form-attribute-memberType"
                                        label="Тип поля"
                                        value={fields.memberType || ""}
                                        onChange={(ev) => { setFields((state) => ({ ...state, memberType: ev.target.value })) }}
                                        required
                                    >
                                        {memberTypeOptions.map(opt => (
                                            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField margin="normal"
                                           multiline
                                           minRows={2}
                                           fullWidth label="Member Description"
                                           onChange={(ev) => { setFields((state) => ({ ...state, memberDescription: ev.target.value })) }}
                                           value={fields.memberDescription || ""}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <LoadingButton style={{marginTop: "10px"}} variant="contained" onClick={() => { submit() }}>
                    Сохранить
                </LoadingButton>
            </>}
        </DashboardLayout>
    )
}

export default FormAttributeDetailForm


